// Domain publication validation V1; 2026-10-31 23:12:19 CST; parent 81bdb256d5b7a94bb5a1265d806ce53aef0e0494.
// Console V0.1.130; 2026-10-02 20:51:43 CST; parent 5abb11ed04c30c2573a4557e316fd48d656507ca; CDN-RELIABILITY-20261002.
import type { Origin, OriginCreatePayload } from '../api/types';

/** Give immediate guidance; the Agent also validates every rendered package. */
export function validateOriginCompatibility(candidate: OriginCreatePayload, peers: Origin[], editingId?: number | null) {
  for (const peer of peers.filter(row => row.id !== editingId && row.status !== 'DISABLED')) {
    if (peer.protocol !== candidate.protocol) throw new Error('主备源站不能混用 HTTP/HTTPS：请先核实每个源站的协议和端口，再配置协议一致、实际可用的备用源站。');
    if ((peer.host || candidate.host).toLowerCase() !== candidate.host.toLowerCase()) throw new Error('主备回源 Host 必须一致；不同站点不能共用当前回源组。');
    if (candidate.protocol !== 'HTTP' && (peer.tlsSni || peer.host || candidate.host).toLowerCase() !== (candidate.tlsSni || candidate.host).toLowerCase()) throw new Error('主备回源 SNI 必须一致；请核对源站证书及域名。');
  }
}

/** A frontend may accept both HTTP and HTTPS, but one origin group shares one transport. */
export function validateOriginProtocols(endpoints: ReadonlyArray<Pick<OriginCreatePayload, 'protocol'>>) {
  if (new Set(endpoints.map(endpoint => endpoint.protocol)).size > 1) {
    throw new Error('主备源站不能混用 HTTP/HTTPS：请先核实每个源站的协议和端口，再配置协议一致、实际可用的备用源站。');
  }
}
